// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_GetCustomerByIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/getCustomerByID/{id}
 *
 * Returns a single cliente record with datetime fields converted to ISO 8601 UTC.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_GetCustomerByIdResponseDados {
cliente_id?: number
cliente_nome?: string
cliente_cpf?: string
cliente_document_type?: string
cliente_email?: string
cliente_data_nascimento?: string
cliente_genero?: string
cliente_ddi?: string
cliente_ddd?: string
cliente_telefone?: string
cliente_cep?: string
cliente_rua?: string
cliente_numero?: string
cliente_complemento?: string
cliente_bairro?: string
cliente_location_id?: number
cliente_location_type?: string
cliente_franquia_id?: number
cliente_obs?: string
cliente_data_cadastro?: string
cliente_data_ultimo_orcamento?: string
cliente_data_ultimo_compromisso?: string
cliente_qtd_compromissos?: number
cliente_data_ultimo_contato_fidelizacao?: string
cliente_status?: number
cliente_origem_id?: number
cliente_categoria?: string
cliente_profissao?: string
}

export type Clientes_GetCustomerByIdResponse = ApiResponse<Clientes_GetCustomerByIdResponseDados>;

registerResponseContract('Clientes_GetCustomerByIdResponse', {
  cliente_id:                              { type: 'number',  required: false },
  cliente_nome:                            { type: 'string',  required: false },
  cliente_cpf:                             { type: 'string',  required: false },
  cliente_document_type:                   { type: 'string',  required: false },
  cliente_email:                           { type: 'string',  required: false },
  cliente_data_nascimento:                 { type: 'string',  required: false },
  cliente_genero:                          { type: 'string',  required: false },
  cliente_ddi:                             { type: 'string',  required: false },
  cliente_ddd:                             { type: 'string',  required: false },
  cliente_telefone:                        { type: 'string',  required: false },
  cliente_cep:                             { type: 'string',  required: false },
  cliente_rua:                             { type: 'string',  required: false },
  cliente_numero:                          { type: 'string',  required: false },
  cliente_complemento:                     { type: 'string',  required: false },
  cliente_bairro:                          { type: 'string',  required: false },
  cliente_location_id:                     { type: 'number',  required: false },
  cliente_location_type:                   { type: 'string',  required: false },
  cliente_franquia_id:                     { type: 'number',  required: false },
  cliente_obs:                             { type: 'string',  required: false },
  cliente_data_cadastro:                   { type: 'string',  required: false },
  cliente_data_ultimo_orcamento:           { type: 'string',  required: false },
  cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
  cliente_qtd_compromissos:                { type: 'number',  required: false },
  cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
  cliente_status:                          { type: 'number',  required: false },
  cliente_origem_id:                       { type: 'number',  required: false },
  cliente_categoria:                       { type: 'string',  required: false },
  cliente_profissao:                       { type: 'string',  required: false },
})
